import { createFileRoute, redirect } from '@tanstack/react-router';
import { ADMIN_SYSTEM_MONITOR_RUNS } from '@/lib/constants/routes';

export const Route = createFileRoute('/admin/_layout/system-monitor/_layout/')({
  beforeLoad: () => {
    throw redirect({ to: ADMIN_SYSTEM_MONITOR_RUNS });
  },
});
